import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";
import { apiDeleteEmission } from "../../../api/ApiEmission";

const ModalDelete = (props) => {
  const { t } = useTranslation();
  const { id, show, handleClose, handleRecupDatas } = props;

  const submitData = async () => {
    await apiDeleteEmission(id);
    handleRecupDatas();
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("admin.PageAdminMedias.supprimer")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{t("admin.PageAdminMedias.confirmerSupprimer")}</Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          {t("commun.form.button.annuler")}
        </Button>
        <Button variant="success" onClick={submitData}>
          {t("commun.form.button.confirmSuppression")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDelete;
